module.exports = {
  'name': 'e',
  'category': 'Constants',
  'syntax': [
    'e'
  ],
  'description': 'Euler\'s number, the base of the natural logarithm. Approximately equal to 2.71828',
  'examples': [
    'e',
    'e ^ 2',
    'exp(2)',
    'log(e)'
  ],
  'seealso': ['exp']
};



//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/expression/docs/constants/e.js
// module id = 435
// module chunks = 0